var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["a"]: () => __WEBPACK_EXTERNAL_MODULE_humanize_duration_ea56f17f__["default"] });